import { ChangePasswordWidgetData } from './types';
import { INITIAL_SAVE_REQUEST_META } from '../utils';

const defaultChangePasswordWidgetData: NonNullable<ChangePasswordWidgetData['initialData']> = {
  currentPassword: '',
  newPassword: '',
  newPasswordRepeat: '',
};

export const defaultChangePasswordWidgetState: ChangePasswordWidgetData = {
  initialData: defaultChangePasswordWidgetData,
  currentData: defaultChangePasswordWidgetData,
  isDirty: false,
  saveRequest: INITIAL_SAVE_REQUEST_META,
};
